import { TableCell, TableRow } from "@mui/material";

import { OrthoApprovalStatus } from "api/model";
import type { LocationOrtho } from "context/CogOrtho";
import type { OrthoWorkflow } from "context/OrthoWorkflow";

import type { AnalysisKind } from "./analysisRunPlan";
import AnalysisTaskCell from "./AnalysisTaskCell";

export interface AnalysisCellToggle {
  isToggled: boolean;
  onToggle: () => void;
}

interface AnalysisEnclosingOrthoItemProps {
  label: string;
  ortho: LocationOrtho;
  toggles: Readonly<Record<AnalysisKind, AnalysisCellToggle>>;
  trialId: number;
  workflow: OrthoWorkflow | undefined;
}

/** Why an ortho that isn't approved can't be analyzed yet. */
const getUnapprovedMessage = (status: OrthoApprovalStatus): string => {
  switch (status) {
    case OrthoApprovalStatus.approved:
      return "";
    case OrthoApprovalStatus.pending:
      return "Ortho Pending Approval";
    case OrthoApprovalStatus.rejected:
      return "Ortho Rejected";
    case OrthoApprovalStatus.processing:
      return "Ortho Processing";
    case OrthoApprovalStatus.uploading:
      return "Ortho Uploading";
  }
};

/** One table row per ortho: a select box or status for each analysis. */
const AnalysisEnclosingOrthoItem: React.FC<AnalysisEnclosingOrthoItemProps> = ({
  label,
  ortho,
  toggles,
  trialId,
  workflow,
}) => (
  <TableRow aria-label={label} hover>
    <TableCell component="th" scope="row" sx={{ py: 0.25 }}>
      {label}
    </TableCell>
    {ortho.status === OrthoApprovalStatus.approved ? (
      <>
        <AnalysisTaskCell
          isToggled={toggles.canopy.isToggled}
          kind="canopy"
          onToggle={toggles.canopy.onToggle}
          orthoLabel={label}
          trialId={trialId}
          workflow={workflow}
        />
        <AnalysisTaskCell
          isToggled={toggles.emergence.isToggled}
          kind="emergence"
          onToggle={toggles.emergence.onToggle}
          orthoLabel={label}
          trialId={trialId}
          workflow={workflow}
        />
      </>
    ) : (
      <TableCell align="center" colSpan={2} sx={{ py: 0.25 }}>
        {getUnapprovedMessage(ortho.status)}
      </TableCell>
    )}
  </TableRow>
);

export default AnalysisEnclosingOrthoItem;
